import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { InlineSvgComponent } from '../inline-svg/inline-svg.component';
import { TooltipDirective } from '../tooltip/tooltip.directive';

export type UnderDevelopmentPosition = 'top' | 'bottom' | 'start' | 'end' | 'inline';

@Component({
  selector: 'ui-under-development',
  imports: [ CommonModule, InlineSvgComponent, TranslocoModule, TooltipDirective ],
  templateUrl: './under-development.component.html',
  styleUrl: './under-development.component.scss',
})
export class UnderDevelopmentComponent {
  /** The position of the label relative to the target element. `inline` keeps it in the flow. */
  position = input<UnderDevelopmentPosition>('top');
  /** The position of the tooltip relative to the label. */
  tooltipPosition = input<'top' | 'bottom' | 'start' | 'end'>('top');
  /** If the label is extended (has text) or not. */
  extended = input<boolean>(false);
}
